import Keycloak from 'keycloak-js';

const login = () => {
  const keycloak = Keycloak('/keycloak.json');
  return keycloak.init({onLoad: 'login-required'}).then(authenticated => {
    return {user: keycloak, authenticated: authenticated};
  })
}

const logout = () => {
  localStorage.removeItem('_keycloakUser');
  localStorage.removeItem('_loy3User');
  localStorage.removeItem('_loy3MembershipInfo');
}

export const userService = {
  login,
  logout
};
